import { ToastContainerProps } from 'react-toastify';

export const defaultToastConfig: ToastContainerProps = {
  position: 'bottom-center',
  autoClose: false,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  closeButton: false,
  toastClassName: () => 'no-padding',
  style: { boxShadow: 'none', padding: 0, background: 'none', width: 'fit-content', zIndex: 99 },
};
